export default [
    {
      path: '/admin/kot-bot-printers',
      name: 'kot-bot-printer',
      meta: { requiresAuth: true },
      component: () => import('@/pages/restaurant-sale/kot-bot-printer/index.vue')
    },
    {
      path: '/admin/kot-bot-printers/:id',
      name: 'kot-bot-printer-edit',
      meta: { requiresAuth: true },
      component: () => import('@/pages/restaurant-sale/kot-bot-printer/index.vue')
    }
  ]
  